import React from "react";
import "./style.scss";
import EATextField from "../../app/components/shared/TextField/EATextField";

interface IProps {
  value: string;
  label: string;
  name: string;
  type:string;
  setValue: (value: string) => void;
}

const InputText: React.FC<IProps> = ({ value, label, name, setValue, type }: IProps) => {
  return (
    // <div className={"form-input-text"}>
    //   <label htmlFor={name}>{label}</label>
    //   <input type="text" value={value} name={name} onChange={event => setValue(event.target.value)} />
    // </div>

<EATextField
label={label}
name={name}
placeholder={label}
value={value}
onChange={event => setValue(event.target.value)}
fullWidth
/>

  );
};

export default InputText;
